(ns practitest.frontend.planned-vs-executed-chart
  (:require [practitest.frontend.common.utils :as utils]
            [practitest.frontend.init :as init]
            [practitest.frontend.components2.dashboard.chart :as chart]
            [clojure.string :as str]))

(defn root-view [{:keys [data-item-id data-edit-url data-warning]}]
  [chart/chart #:chart{:id       (js/Number data-item-id)
                       :type     ::chart/planned-vs-executed
                       :edit-url data-edit-url
                       :warning  (when (and (string? data-warning)
                                            (not (str/blank? data-warning)))
                                   (js->clj (js/JSON.parse data-warning) :keywordize-keys true))}])

(defn ^:dev/after-load remount-roots []
  (init/remount-roots "planned-vs-executed-chart-component" root-view))

(utils/register-webcomponent! "planned-vs-executed-chart-component")